import { Tooltip } from "@mui/material";

export const ButtonsCreate = (props) => {
  const {
    justIcon = false,
    title = null,
    name = null,
    icon = null,
    icon2 = null,
    handleClick = () => false,
    disabled = false,
  } = props;

  return (
    <Tooltip title={title}>
      {justIcon ? (
        <button
          className="flex justify-center items-center w-12 h-12 rounded-full  bg-[var(--primary-color)] text-white shrink-0 outline-none"
          onClick={handleClick}
          disabled={disabled}
        >
          {icon}
        </button>
      ) : (
        <button
          className="text-sm bg-[var(--primary-color)] text-white rounded-lg flex items-center gap-1 p-2 shrink-0 min-h-11"
          onClick={handleClick}
          disabled={disabled}
        >
          {icon}
          <span>{name}</span>
          {icon2}
        </button>
      )}
    </Tooltip>
  );
};
